import { Api } from 'models/services/api';
import { DeleteDishCategoryQuery } from 'models/services/graphql';

import { DishCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteDishCategory($id: ID!) {
    ${DeleteDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteDishCategory: DishCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: DishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };